// ArchitecturalRequestsContainer.tsx
import React, { useEffect, useState } from 'react';
import { Tabs, Card } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import ArchitecturalRequestList from '../ArchitecturalRequest/ArchitecturalRequestList';
import ArchitecturalRequests from '../../AccountSummaryGroup/ArchitecturalRequests/ArchitecturalRequests';

/**
 * Shows two tabs:
 * - Completed -> ArchitecturalRequests
 * - Pending   -> ArchitecturalRequestList
 *
 * Syncs tab with ?tab=completed|pending query parameter so tabs are linkable.
 */

const { TabPane } = Tabs;

function getTabFromSearch(search: string): 'completed' | 'pending' {
    try {
        const params = new URLSearchParams(search);
        const t = params.get('tab');
        if (t === 'completed') return 'completed';
        return 'pending';
    } catch {
        return 'pending';
    }
}

const ArchitecturalRequestsContainer: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState<'completed' | 'pending'>(
        getTabFromSearch(location.search)
    );

    // Keep state in sync when user navigates directly with URL or uses back/forward
    useEffect(() => {
        const tab = getTabFromSearch(location.search);
        setActiveTab(tab);
    }, [location.search]);

    const onTabChange = (key: string) => {
        const tabKey = key === 'completed' ? 'completed' : 'pending';
        // update URL query param without losing path
        const params = new URLSearchParams(location.search);
        params.set('tab', tabKey);
        navigate(`${location.pathname}?${params.toString()}`, {
            replace: false,
        });
        // state will sync from location.search effect, but set it immediately for snappier UI
        setActiveTab(tabKey);
    };

    return (
        <Card bodyStyle={{ padding: 16 }}>
            <Tabs activeKey={activeTab} onChange={onTabChange}>
                <TabPane tab="Requests" key="pending">
                    {/* Pending shows ArchitecturalRequestList */}
                    <ArchitecturalRequestList />
                </TabPane>
                <TabPane tab="History" key="completed">
                    {/* Completed shows ArchitecturalRequests */}
                    <ArchitecturalRequests />
                </TabPane>
            </Tabs>
        </Card>
    );
};

export default ArchitecturalRequestsContainer;
